<template>
  <el-table
    @selection-change="changeCheckBoxValue"
    :data="tableData"
    ref="refTable"
    height="65vh"
    style="width: 100%;"
    border>
    <template v-for="item in tableColumns">
      <el-table-column :key="item.field"  type="selection" v-if="item.field === 'checkBox'"></el-table-column>
      <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width="item.width"
                       :formatter="item.formatter" :align="item.align"
                        v-else-if="item.field === 'levelId' && item.isShow">


        <template v-slot="scope">
          <span :style="{'color':scope.row.levelColor}">{{ scope.row.levelName }}</span>
        </template>
      </el-table-column>
      <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width="item.width"
      :align="item.align"  v-else-if="item.field === 'deviceName'">
        <template v-slot="scope">

        <a type="text" size="mini"
                @touchstart="handleToView(scope.row)"
                @click="handleToView(scope.row)"
               style="border-bottom: 1px solid; text-decoration:none;color:white;cursor: pointer"
               slot="reference">{{
                scope.row.deviceName
              }}</a>
              </template>
      </el-table-column>
      <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width="item.width"
                       :formatter="item.formatter" :align="item.align"
                       v-else-if="item.field === 'msg' && item.isShow">
        <template v-slot="scope">
          <el-popover v-if="item.field === 'msg'"
                      popper-class="popoverClass"
                      placement="bottom"
                      trigger="hover"
                      width="330"
                      size="mini">
            <b-button v-if="!scope.row.isConfirm" style="color: #07E6F8;" size="mini" variant="text"
              @touchstart="handleToView(scope.row)" @click="alarmHandling(scope.row.id)">处理
            </b-button>
            <b-button v-if="!scope.row.isProcess" style="color: #F95453" size="mini" variant="text"
              @touchstart="alarmElimination(scope.row.id)" @click="alarmElimination(scope.row.id)">消警
            </b-button>
            <b-button variant="text" style="color: #FEDB5B" size="mini" @touchstart="viewLog(scope.row)"  @click="viewLog(scope.row)">查看日志
            </b-button>
            <b-button variant="text" style="color: #60a7f3" size="mini" v-if="scope.row.isLinkageVideo"
               @touchstart="historyVideo(scope.row.cameraId,scope.row.videoId)"  @click="videoLinkageButton(scope.row)">视频联动
            </b-button>
            <a type="text" size="mini"
               style="border-bottom: 1px solid; text-decoration:none;color:white;cursor: pointer"
               slot="reference">{{
                scope.row.msg
              }}</a>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width="item.width"
                       :formatter="item.formatter" :align="item.align"
                       v-else-if="item.field === 'ticketNo' && tickSystem && item.isShow">
      </el-table-column>

      <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width="item.width"
                       :formatter="item.formatter" :align="item.align" v-else-if="item.isShow">
      </el-table-column>
    </template>
  </el-table>
</template>
<script>

export default {
  name: "tableComponent",
  components: {},
  props: {
    tableData: {
      type: [Array, Object],
      required: true
    },
    tableColumns: {
      type: [Array, Object],
      required: true
    },
    tickSystem:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  watch: {},
  methods: {
    changeCheckBoxValue(val){
      this.$emit('changeCheckBoxValue',val)
    },
    alarmHandling(id){
      this.$emit('alarmHandling',id)
    },
    alarmElimination(id){
      this.$emit('alarmElimination',id)
    },
    viewLog(row){
      this.$emit('viewLog',row)
    },
    videoLinkageButton(row){
      this.$emit('videoLinkageButton',row)
    },
    handleToView(row) {
      this.$emit('handleToView', row)
    }
  }
}
</script>

<style scoped>

</style>
